<template>
  <CompanyForm :company="resource"
              :countries="countries"
               @formSubmit="formSubmitted($event)" />
</template>

<script>
import store from "./CompanyStore";
import SetupStore from "../Setup/SetupStore";
import CountryStore from "../../../dashboard/stores/CountryStore";

import CompanyForm from "./CompanyForm.vue";
import CompanyMixin from "./CompanyMixin";

const responseStore = {
  response: {
    resource: {
      map_setting: 0
    }
  },
  countries: []
};

const fetchResource = async (to, from, next) => {
  responseStore.countries = await CountryStore.collection("public");

  next();
};

export default {
  name: "CompanyNew",

  title () {
    return this.$t("company.newProfile") + ` - ${Dashboard.currentTenant.name}`;
  },

  beforeRouteEnter: fetchResource,
  beforeRouteUpdate: fetchResource,

  components: {
    CompanyForm
  },

  mixins: [CompanyMixin],

  data: function () {
    return {
      responseStore: this.$_.cloneDeep(responseStore)
    };
  },

  computed: {
    countries () {
      return responseStore.countries;
    }
  },

  methods: {
    async formSubmitted (e) {
      tinyMCE.triggerSave();

      let response = this.handleResponseToEdit(await store.create(this.$route.params));
      if (response.success) {
        store.refreshCompany(response);
        SetupStore.refreshState();
        this.responseStore.response = response;
      }
    }
  }
};
</script>
